<template>
  <div>
    <ControlBar
      v-model="item"
      :title="title"
      :readOnly="false"
    >
    </ControlBar>
    <div v-if="item">
      <div class="setting-section-block">
        <div class="section-top">
          <AGCCard class="status-card">
            <div class="status-card__toolbar">
              <span>最後登入時間: {{ formatLastLoginTime }}</span>
            </div>
          </AGCCard>
        </div>
        <div class="section-bottom">
          <div class="d-flex justify-content-between align-self-center my-4">
            <span class="title">營銷人員資料</span>
          </div>
          <AGCEditGroupInput
            v-model="item.username"
            :fieldName="'username'"
            name="營銷人員名稱"
            label="營銷人員名稱"
            type="text"
            disabled
            rules=""
            :readOnly="true"
          />
          <AGCEditGroupInput
            v-model="item.email"
            :fieldName="'email'"
            name="營銷人員電郵"
            label="營銷人員電郵"
            type="text"
            disabled
            rules=""
            :readOnly="true"
          />
          <div class="d-flex justify-content-between align-self-center my-4">
            <span class="title">已分配商户</span>
          </div>
          <AGCEditGroupInput
            v-model="item.merchants"
            :inputType="'formTag'"
            :fieldName="'merchants'"
            label="商户名稱"
            name="商户名稱"
            placeholder=""
            rules=""
            :readOnly="true"
          >
          </AGCEditGroupInput>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import {
  tap,
  pluck,
  startWith,
  switchMap,
} from 'rxjs/operators';
import http from '@/helpers/http';
import AGCCard from '@/components/AGCCard.vue';
import ControlBar from '@/components/sale/ControlBar.vue';
import AGCEditGroupInput from '@/components/form/AGCEditGroupInput.vue';
import formMixin from '@/mixins/form';

export default {
  mixins: [formMixin],
  props: {
    publicApi: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ControlBar,
    AGCCard,
    AGCEditGroupInput,
  },
  data: () => ({
    item: null,
    title: '',
  }),
  computed: {
    ...mapGetters(['role']),
    ...mapState(['user']),
    backUrl() {
      return `/${this.role}/sales`;
    },
    id() {
      return this.$route.params.id;
    },
    apiUrl() {
      return `/agc-${this.role}-api/sales/`;
    },
    formatLastLoginTime() {
      if (this.item.lastLoginTime) {
        return this.item.lastLoginTime.substring(0, 19);
      }
      return '';
    },
  },
  subscriptions() {
    const getData$ = (id) => http({
      method: 'GET',
      url: this.apiUrl + id,
    });

    return {
      data$: this.$watchAsObservable('id')
        .pipe(
          pluck('newValue'),
          startWith(this.id),
          switchMap(getData$),
          tap((sale) => {
            this.item = sale;
            this.item.merchants = this.item.merchants ? this.item.merchants.split(',') : [];
            this.title = sale.username;
          }),
        ),
    };
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
.setting-section-block{
  background: #fff;
  box-sizing: border-box;
  border: 1px solid #DDE1E5;
  border-radius: 4px;
  overflow: hidden;
  margin:auto;
  max-width:800px;
  margin-bottom:10px;

  @media (max-width: 765px) {
    padding:0px 16px;
    border:0px;
    font-size: 14px;
  }

  @media (max-width: 576px) {
    border: 0px;
    border-radius: 0px;
    background: none;
    margin-bottom:0px;
  }

  label {
    font-weight: 400;
    font-size: 15px;

    @media (max-width: 576px) {
      font-size: 0.98em;
      padding-right: 5px;
    }
  }

  & .section-top{
    width:100%;
    display:inline-block;
    position: relative;
    background-color: none;
  }
  & .section-bottom{
    width:100%;
    display:inline-block;
    padding: 0 24px;
    background: #fff;
    margin-top: -5px;

    @media (max-width: 765px) {
      padding: 0 12px;
    }
    &::v-deep {
      & .title{
        color: #3A4047;
        font-size: 1.125rem;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 25px;
      }
      & .sub-title{
        color: #636D77;
        font-size: 0.875rem;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 20px;
      }
      & .border-bottom{
        border-bottom: 1px solid #EBEEF0 !important;
        margin-left: 0;
        margin-right: 0;
        box-sizing:border-box;
        padding: 10px 15px 6px 0 !important;
        & div:not(.thumbnail-preview-item){
          padding:0px;
          & label{
            color:#636d77;
            font-weight:400;
          }
        }
      }
      .form-group{
        padding:5px 0px;
        margin-bottom:0px;
        box-sizing:border-box;
      }
      .form-control{
        background:#F9F9FA;
        font-size: 15px;
        @media (max-width: 576px) {
          font-size: 0.98em;
        }
      }
      .form-control:disabled{
        background:none;
        border:none;
      }
      .btn {
        line-height: 18px;
        font-weight: 500;
        font-size: 14px;

        &-light {
          background-color: #f9f9fa;
          border: 1px solid #dde1e5;
          color: #636d77;
        }
      }
    }
  }
}

.status-card {
  &__toolbar {
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    background: #318ce1;
    color: white;
    font-size: 15px;
    font-weight: 500;

    & a {
      cursor: pointer;
    }
  }
}
</style>
